var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "app"
    }
  }, [_vm.isLoginshow ? _c("Header") : _vm._e(), _vm.isHomeShow ? _c("BackMenu", {
    attrs: {
      result: _vm.result
    }
  }) : _vm._e(), _c("div", {
    staticClass: "panel"
  }, [_vm.isRouterAlive ? _c("router-view") : _vm._e(), _vm.isFooterShow ? _c("Footer") : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };